export default __webpack_public_path__ + "static/media/pro2.0a0c9cc1.png";